export default {
  props: {
    destination: {
      type: Object,
      required: false
    },
    bgColor: {
      type: String,
      required: false,
      default: () => "#001d38"
    },
    textColor: {
      type: String,
      required: false,
      default: () => "#FFFFFF"
    }
  },
  computed: {
    cards() {
      return [
        {
          image: "/img/icons/checkin.svg",
          title: "Check-in",
          included: true,
          copy: this.$t('shared.recive_cards_24')
        },
        {
          image: "/img/icons/bag-white.svg",
          title: this.$t('shared.hand_bag'),
          included: true,
          copy: this.$t('shared.you_may_carry_a_bag')
        },
        {
          image: "/img/icons/transfer.svg",
          title: this.$t('shared.transfer_to_center'),
          included: false,
          copy: `${this.$t('shared.bus_to_center')} ${this.destination && this.destination.name}. ${this.$t('shared.from_airport_to_center')}`
        },
        {
          image: "/img/icons/seat.svg",
          title: this.$t('shared.sitting_together'),
          included: false,
          copy: this.$t('shared.some_airlines_seats_separated')
        }
      ];
    }
  }
};
